/* istanbul ignore next */
import { ESortOrder } from '../types/sortOrder';
import { IGetRatingListResponseDataAttributes } from '../services/getRealtorRatingList';

/** Колонки таблицы рейтинга */
export enum ERealtorRatingTableColumns {
  Number = 'number',
  Specialist = 'specialist',
  Rating = 'rating',
  AdviceCountAll = 'adviceCountAll',
  AdviceCountBest = 'adviceCountBest',
  BlogCountAll = 'blogCountAll',
  BlogCountPopular = 'blogCountPopular',
  ReviewCountAll = 'reviewCountAll',
  ReviewCountPopular = 'reviewCountPopular',
}

/** Заголовки колонок таблицы рейтинга */
export const RealtorRatingTableColumnLabels: { [key in ERealtorRatingTableColumns]: string } = {
  [ERealtorRatingTableColumns.Number]: '',
  [ERealtorRatingTableColumns.Specialist]: 'Специалист',
  [ERealtorRatingTableColumns.Rating]: 'Рейтинг',
  [ERealtorRatingTableColumns.AdviceCountAll]: 'Все',
  [ERealtorRatingTableColumns.AdviceCountBest]: 'Лучшие',
  [ERealtorRatingTableColumns.BlogCountAll]: 'Все',
  [ERealtorRatingTableColumns.BlogCountPopular]: 'Популярные',
  [ERealtorRatingTableColumns.ReviewCountAll]: 'Все',
  [ERealtorRatingTableColumns.ReviewCountPopular]: 'Популярные',
};

/** Заголовки колонок таблицы рейтинга */
export const RealtorRatingTableSortableColumns: { [key in ERealtorRatingTableColumns]: boolean } = {
  [ERealtorRatingTableColumns.Number]: false,
  [ERealtorRatingTableColumns.Specialist]: false,
  [ERealtorRatingTableColumns.Rating]: true,
  [ERealtorRatingTableColumns.AdviceCountAll]: true,
  [ERealtorRatingTableColumns.AdviceCountBest]: true,
  [ERealtorRatingTableColumns.BlogCountAll]: true,
  [ERealtorRatingTableColumns.BlogCountPopular]: true,
  [ERealtorRatingTableColumns.ReviewCountAll]: true,
  [ERealtorRatingTableColumns.ReviewCountPopular]: true,
};

/** Заголовки колонок таблицы рейтинга */
export const RealtorRatingTableSortableColumnNames: {
  [key in ERealtorRatingTableColumns]: keyof IGetRatingListResponseDataAttributes;
} = {
  [ERealtorRatingTableColumns.Number]: 'rating',
  [ERealtorRatingTableColumns.Specialist]: 'rating',
  [ERealtorRatingTableColumns.Rating]: 'rating',
  [ERealtorRatingTableColumns.AdviceCountAll]: 'advicesCount',
  [ERealtorRatingTableColumns.AdviceCountBest]: 'bestAdvicesCount',
  [ERealtorRatingTableColumns.BlogCountAll]: 'blogsCount',
  [ERealtorRatingTableColumns.BlogCountPopular]: 'popularBlogsCount',
  [ERealtorRatingTableColumns.ReviewCountAll]: 'reviewsCount',
  [ERealtorRatingTableColumns.ReviewCountPopular]: 'popularReviewsCount',
};

/** Значение по умолчанию для колонки сортировки */
export const REALTOR_RATING_SORT_ORDERING_DEFAULT = ERealtorRatingTableColumns.Rating;

/** Значение по умолчанию для типа сортировки */
export const REALTOR_RATING_SORT_ORDERING_TYPE_DEFAULT = ESortOrder.Desc;

/** Значение по умолчанию для фильтра Регион */
export const REALTOR_RATING_DEFAULT_REGION_VALUE = 0;

/** Значение по умолчанию для фильтра Период */
export const REALTOR_RATING_DEFAULT_PERIOD_VALUE = 'all';

/** Минимальный год для фильтра Период */
export const REALTOR_RATING_MIN_PERIOD = 2010;

/** Имя qs-параметра для колонки сортировки */
export const REALTOR_RATING_SORT_ORDERING_QS_NAME = 'sort-ordering';

/** Имя qs-параметра для типа сортировки */
export const REALTOR_RATING_SORT_ORDERING_TYPE_QS_NAME = 'sort-ordering-type';

/** Имя qs-параметра для фильтра Регион */
export const REALTOR_RATING_REGION_QS_NAME = 'location';

/** Имя qs-параметра для фильтра Период */
export const REALTOR_RATING_PERIOD_QS_NAME = 'year';
